import { useEffect, useState } from "react";

export const IOS_SAFE_AREA_TOP_FALLBACK_PX = 44;

export function isLikelyIOS(navigatorObj: Pick<Navigator, "userAgent" | "platform" | "maxTouchPoints">) {
  return /iPad|iPhone|iPod/.test(navigatorObj.userAgent)
    || (navigatorObj.platform === "MacIntel" && navigatorObj.maxTouchPoints > 1);
}

export function getSafeAreaTopFallbackPx(isIOS: boolean, envSafeTop: number, isStandalone: boolean) {
  if (!isIOS) return 0;
  // Only apply fallback in standalone/PWA mode where the browser chrome is absent
  if (!isStandalone) return 0;
  return envSafeTop > 0 ? 0 : IOS_SAFE_AREA_TOP_FALLBACK_PX;
}

function readEnvSafeAreaTopPx() {
  if (typeof document === "undefined") return 0;

  const probe = document.createElement("div");
  probe.style.position = "absolute";
  probe.style.visibility = "hidden";
  probe.style.pointerEvents = "none";
  probe.style.paddingTop = "env(safe-area-inset-top)";
  document.body.appendChild(probe);

  const envSafeTop = Number.parseFloat(getComputedStyle(probe).paddingTop) || 0;
  document.body.removeChild(probe);

  return envSafeTop;
}

export function useSafeAreaTop() {
  const [fallbackPx, setFallbackPx] = useState(0);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const isiOS = isLikelyIOS(globalThis.navigator);
    const envSafeTop = readEnvSafeAreaTopPx();
    const isStandalone = window.matchMedia("(display-mode: standalone)").matches
      || (window.navigator as any).standalone === true;
    setFallbackPx(getSafeAreaTopFallbackPx(isiOS, envSafeTop, isStandalone));
  }, []);

  return fallbackPx;
}
